import { computed, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { loop } from '@/utils/loop';
import { userapi } from '@/apis/unified';
import { useSymbol } from '@/hooks/exchange';

/**
 * 账户余额信息
 */
export function useUnifiedBalance() {
    let unSubBalance = null;
    const store = useStore();
    const symbol = useSymbol();
    const userstate = computed(() => store.state.user.userstate);
    const isUTA = computed(() => store.getters['user/isUTA']);

    const clearSubBalance = () => {
        if (unSubBalance) {
            unSubBalance();
            unSubBalance = null;
        }
    };

    watch([
        () => symbol.value.symbolId,
        () => userstate.value,
        () => isUTA.value], ([symbolId, userStatus, isUnified]) => {
        if (userStatus !== 1) return;

        clearSubBalance();
        if (symbolId && isUnified) {
            unSubBalance = loop(async () => {
                const { baseTokenId, quoteTokenId } = symbol.value;
                const res = await userapi.getUnifiedAsset({ symbolName: symbol.value.symbolId });
                if (res.success && res.result) {
                    store.commit('balance/SET_UNIFIED_BALANCES', res.result);
                    const { coinList } = res.result;
                    if (coinList && coinList.length) {
                        const available = {};
                        coinList.forEach((item) => {
                            available[item?.tokenId] = item;
                        });
                        store.commit('balance/SET_ACCOUNT_INFO', {
                            buyTotalAvailable: available[quoteTokenId]?.spotMarginAvailableBalance || '0',
                            sellTotalAvailable: available[baseTokenId]?.spotMarginAvailableBalance || '0',
                            baseBorrowSize: available[baseTokenId]?.borrowSize || '0',
                            quoteBorrowSize: available[quoteTokenId]?.borrowSize || '0',
                        });
                    }
                }
            }, {
                interval: 3e3,
                immediate: true,
            });
        }
    }, { immediate: true });

    onBeforeUnmount(clearSubBalance);
}
